export const LIST_ROUTE = "/viewApplicationTaskList";
export const DEFAULT_NEXT_ROUTE = "CertificateGroupingApprove";

// templateId -> next screen
export const NEXT_ROUTE_BY_TEMPLATE = {
    1: "CertificateGroupingCommonForFinalReview",
    2: "CertificateGroupingCommonForFinalReview",
    3: "CertificateGroupingGWPConcreteForFinalReview",
    4: "CertificateGroupingGWPConcreteForFinalReview",
    5: "CertificateGroupingGWPGeneralForFinalReview",
    6: "CertificateGroupingGWPGeneralForFinalReview",
    7: "CertificateGroupingListTVOCFinalReview",
    8: "CertificateGroupingListTVOCFinalReview",
};

export const RATING_LEVELS = [1, 2, 3, 4];

export const LOCKED_TEXTAREA_STYLE = { background: "#f5f5f5", cursor: "not-allowed" };